import { inject, Injectable } from '@angular/core';

import { forkJoin, map, Observable } from 'rxjs';

import { InitializationResult, UserInitialization } from '@core/models/user-initialization.interface';

import { FacilityDashboardApiService } from './facilility-dashboard-api.service';

@Injectable({
  providedIn: 'root',
})
export class FacilityInitializationService implements UserInitialization {
  private readonly facilityDashboardApiService = inject(FacilityDashboardApiService);

  public initialize(): Observable<InitializationResult> {
    return forkJoin({
      data: this.facilityDashboardApiService.getFacilityDashboardData(),
      avatar: this.facilityDashboardApiService.getHeadOfPracticeAvatar(),
    }).pipe(
      map(({ data, avatar }) => ({
        ...data,
        avatarUrl: URL.createObjectURL(avatar),
      })),
    );
  }
}
